module.exports = __webpack_public_path__ + "img/3.59697a4d.png";